/**
 * Created by Andrey Popov on 07.08.26
 */

cleverapps.Tool.inviteFriends = ToolFolder.create(() => ({
    showWindow: function () {
        cleverapps.focusManager.closeAllWindows();
        cleverapps.inviteFriends.displayWindow();
    },
    showIntro: function () {
        cleverapps.focusManager.closeAllWindows();
        cleverapps.inviteFriends.displayIntro();
    },
    showCongrat: function () {
        cleverapps.focusManager.closeAllWindows();
        cleverapps.inviteFriends.displayCongrat();
    },
    fakeJoin: function () {
        displayToolPrompt((count) => {
            count = parseInt(count);
            if (Number.isNaN(count) || count <= 0) {
                return;
            }
            const ids = Array.from({ length: count }, () => `fake_${Math.random().toString(36).slice(2, 10)}`);
            cleverapps.inviteFriends.addJoined(ids);
        }, "Friends to join", "1");
    },
    syncConnected: function () {
        connector.social.listFriends((code, friends) => {
            console.log("listFriends:", code, friends);
        });
        cleverapps.inviteFriends.syncConnected(() => {
            console.log("syncConnected done", cleverapps.inviteFriends.data);
        });
    },
    claimPending: function () {
        const rewards = cleverapps.inviteFriends.claimPending();
        if (rewards) {
            rewards.receiveRewards();
        }
        console.log("claimed:", Boolean(rewards));
    },
    reset: function () {
        cleverapps.inviteFriends.reset();
    },
    logState: function () {
        console.log(JSON.stringify({
            data: cleverapps.inviteFriends.data,
            isAvailable: cleverapps.inviteFriends.isAvailable(),
            joined: cleverapps.inviteFriends.getJoined(),
            connected: cleverapps.inviteFriends.data.connected || [],
            rewarded: cleverapps.inviteFriends.getRewarded(),
            userId: connector.platform.getUserID()
        }, undefined, 4));
    }
}));
